import React, { useState } from 'react';
import styles from './_style.module.scss';

const SelectQuantity = ({ id, drawing, unit }) => {
  const [value, setValue] = useState(1000);

  return (
    <div className={styles.formGroup}>
      <label className={styles.label}>{t('quote_builder_widget.quantity')}</label>
      <div className={styles.inputWrapper}>
        <input
          type="number"
          className={styles.input}
          value={value}
          onChange={(e) => setValue(() => e.target.value)}
        />
      </div>
    </div>
  );
};

export default SelectQuantity;
